import { useEffect, useState } from "react";
import { hasProductClientId, ynetProductClientId, getUsernameFromEmail } from "../../../../../global/paywall/paywallUtils";
import { UserWithEmail } from "../../../../../global/paywall/paywallInterfaces";


interface PremiumPaywallMobileSigninFinishProps {
  setIsRedirecting ?: (isRedirect: boolean) => void;
  user?: UserWithEmail
}

declare const window: Window & {
 articleId: string;
}
 

export const PremiumPaywallMobileSigninFinish = (props:PremiumPaywallMobileSigninFinishProps) => {
  const [subscribed, setSubscribed] = useState(true);
  const { setIsRedirecting, user } = props;
  const isInsideArticle = typeof window !== "undefined" && window.articleId && window.articleId.length > 0;

  useEffect(() => {
    let timer;
    const isSubscribed = hasProductClientId(user.claims, ynetProductClientId);
    if (!isSubscribed) {
     setIsRedirecting(true);
      setSubscribed(false);
    } else {
      timer = setTimeout(() => {
        isInsideArticle ? location.reload() : setIsRedirecting(true);
      }, 3000);
    }
    return () => {
      clearTimeout(timer);
    }
  }, []);


  if (!subscribed) return null;

  let displayName = user && user.displayName && user.displayName.trim();
  if (!displayName) {
    displayName = getUsernameFromEmail(user.email)
  }

  return (
    <div className="premium-paywall-mobile-signin-finish">
      <div className="title">{`שלום ${displayName}`}</div>
      <div className="subtitle">
        שמחים שחזרת, מיד תיפתח הכתבה
      </div>

      <div className="resend-code-text">
        העמוד לא התרענן?<button onClick={() => isInsideArticle ? location.reload() : setIsRedirecting(true)}>לחצו כאן</button>
      </div>
    </div>
  )
}
